module.exports = __webpack_public_path__ + "static/media/plus-circle-white.c9baa053.svg";